"use client";

import type { ReactNode } from "react";
import { ThemeToggle } from "@/components/layout/theme-toggle";
import { LangSwitcher } from "@/components/layout/lang-switcher";

interface Props {
  children: ReactNode;
}

export function AuthShell({ children }: Props) {
  return (
    <div className="relative min-h-dvh overflow-hidden bg-background text-ink">
      <LightDecor />

      <div className="absolute top-4 right-4 z-20 flex items-center gap-2">
        <LangSwitcher />
        <ThemeToggle />
      </div>

      <main className="relative z-10 flex min-h-dvh items-center justify-center px-4 py-16 sm:px-6">
        {children}
      </main>
    </div>
  );
}

function LightDecor() {
  return (
    <>
      {/* Soft mint glow — top right */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute z-0 select-none"
        style={{
          top: "-20%",
          right: "-15%",
          width: "min(800px, 90vw)",
          height: "min(800px, 90vw)",
          borderRadius: "9999px",
          background: [
            "radial-gradient(circle at 34% 26%, rgba(52,211,153,0.18) 0%, rgba(52,211,153,0) 40%)",
            "radial-gradient(circle at 50% 50%, rgba(232,232,236,0) 0%, rgba(232,232,236,0) 100%)",
          ].join(", "),
          filter: "blur(20px)",
        }}
      />
      {/* Ambient mint wash — bottom left */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute z-0 select-none"
        style={{
          bottom: "-25%",
          left: "-15%",
          width: "min(600px, 70vw)",
          height: "min(600px, 70vw)",
          borderRadius: "9999px",
          background: "radial-gradient(circle at 50% 50%, rgba(52,211,153,0.10) 0%, rgba(52,211,153,0) 60%)",
          filter: "blur(40px)",
        }}
      />
    </>
  );
}
